import { render } from "./ModalIncidencia.vue?vue&type=template&id=7e72a768"
import script from "./ModalIncidencia.vue?vue&type=script&lang=js"
export * from "./ModalIncidencia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__